import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { createGraphQLRequest } from "../../../../../api/utils/httpRequest"
import type { CategoryDetailResponse, Query, QueryCategoryDetailArgs } from "../../../../../graphql/types"

export const fetchCategoryDetailApi = (
    headers: Record<string, any>,
    variables: QueryCategoryDetailArgs
): Promise<Maybe<CategoryDetailResponse>> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                query categoryDetail($categoryId: String!) {
                    categoryDetail(categoryId: $categoryId) {
                        data {
                            id
                            name
                            kitchenName
                            type
                            isActive
                            icon
                            color
                            displayName
                            internalName
                            description
                            parentId
                            parentId
                            fixedPrice
                            unit
                            tare
                            minQuantity
                            maxQuantity
                            pieces
                            containsAlcohol
                            alwaysOpenPopover
                            disableItemNoteKiosk
                            disableItemNoteMiB
                            itemNoteMiBPlaceholder
                            requireItemNoteMiB
                            adjustablePricePOS
                            displayImagePOS
                            barcode
                            pluCode
                            cardProgramId
                            alternativeNames
                            tags
                            images {
                                id
                                path
                                type
                                variants {
                                    id
                                    url
                                    croppedType
                                    cropCoords {
                                        x
                                        y
                                        width
                                        height
                                    }
                                }
                            }
                            taxes {
                                id
                                name
                                isActive
                                isAutoApply
                                isEmbedded
                                parentOverride {
                                    isActive
                                    isAutoApply
                                    isEmbedded
                                }
                            }
                            pricings {
                                id
                                name
                                isActive
                                isAutoApply
                                parentOverride {
                                    isActive
                                    isAutoApply
                                }
                            }
                            modifierGroups {
                                id
                                name
                                isProminent
                                isExclusion
                                modifiers {
                                    id
                                    productId
                                    name
                                    isPreset
                                    isMulti
                                    isActive
                                    price
                                    supplement
                                    nestedCategoryGroupId
                                }
                            }
                            optionGroup {
                                id
                                name
                                isProminent
                                options {
                                    id
                                    productId
                                    name
                                    isPreset
                                    isActive
                                    price
                                    nestedCategoryGroupId
                                }
                            }
                        }
                        overridesV2 {
                            context
                            contextId
                            data                         
                        }
                        overrides {
                            locationId
                            data {
                                id
                                price
                                isActive
                                taxes {
                                    id
                                    isActive
                                    isAutoApply
                                    isEmbedded
                                }
                                pricings {
                                    id
                                    isActive
                                    isAutoApply
                                }
                                modifiers {
                                    id
                                    isPreset
                                    isMulti
                                    isActive
                                    price
                                    supplement
                                }
                                options {
                                    id
                                    price
                                    isPreset
                                    isActive
                                }
                            }
                        }
                    }
                }
            `,
            operationName: "categoryDetail",
            variables: variables,
        },
    }).then(response => {
        if (response && response.data && response.data.categoryDetail) {
            return response.data.categoryDetail
        }

        return null
    })

export type UnmatchedOrderItemNamesResponse = Maybe<Query["unmatchedOrderItemNames"]>

export const fetchUnmatchedOrderItemNamesApi = (
    headers: Record<string, any>
): Promise<UnmatchedOrderItemNamesResponse> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                query unmatchedOrderItemNames {
                    unmatchedOrderItemNames
                }
            `,
            operationName: "unmatchedOrderItemNames",
        },
    }).then(response => {
        if (response && response.data && response.data.unmatchedOrderItemNames) {
            return response.data.unmatchedOrderItemNames
        }

        return null
    })
